<template>
    <button type="button" class="btn btn-primary" :title="title" @click="$emit('click', shared)" :disabled="disabled">
        <span class="fa-stack">
            <i class="fas fa-balance-scale fa-stack-1x"></i>
            <span class="fa-stack share-badge">                
                <i :class="['fas fa-circle fa-stack-2x', shared ? 'text-success': 'text-muted']"></i>
                <i class="fas fa-share fa-stack-1x fa-md text-white"></i>
            </span>
        </span>
    </button>
</template>

<script>
export default {
    props: {
        shared: Boolean,
        disabled: Boolean
    },
    computed: {
        title: function () {
            return this.shared ? 'Stop sharing claim with attorney(s).' : 'Share claim with attorney(s).';
        }
    }
    
}
</script>

<style scoped>
    .share-badge {
        position: relative;
        top: -12px;
        left: 12px;
        display: inline-block;
        font-size: .50em;        
    }
</style>